import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  .prototype-sample.scrollbar-outer {
    height: 250px;
    margin: 50px auto;
    white-space: nowrap;
  }
  .prototype-sample .scrollbar-inner {
    padding: 20px;
  }
  
html,
body,
code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New",
    monospace;
    margin:0;
}

div,
span,
applet,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
pre,
a,
abbr,
acronym,
address,
big,
cite,
code,
del,
dfn,
em,
img,
ins,
kbd,
q,
s,
samp,
small,
strike,
strong,
sub,
sup,
tt,
var,
b,
u,
i,
center,
dl,
dt,
dd,
ol,
ul,
li,
fieldset,
form,
label,
legend,
tfoot,
article,
aside,
canvas,
details,
embed,
figure,
figcaption,
footer,
header,
hgroup,
menu,
nav,
output,
ruby,
section,
summary,
time,
mark,
audio,
textarea,
video {
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  font: inherit;
  vertical-align: baseline;
  box-sizing: border-box;
}

a {
  color: black;
}


/* HTML5 display-role reset for older browsers */
article,
aside,
details,
figcaption,
figure,
footer,
header,
hgroup,
menu,
nav,
section {
  display: block;
}

body {
    font-family: "SDGothicNeobTTF-bLt", Arial, "Helvetica Neue", Helvetica, sans-serif;
    color: #333;
    letter-spacing: -0.025em;
    font-size: 18px;
    background-color: #fff;
}
html {
    -webkit-text-size-adjust: 100%;
    -ms-text-size-adjust: 100%;
    line-height: 1.15;
}
ol,
ul,
li {
  list-style: none;
}

blockquote,
q {
  quotes: none;
}
button {

  font: inherit;
  vertical-align: baseline;
  border: 0;
  background: none;
}
table {
  border-collapse: collapse;
  border-spacing: 0;
}
blockquote:before,
blockquote:after,
q:before,
q:after {
  content: "";
  content: none;
}

a, a:active, a:focus, a:hover, a:link, a:visited {
    color: #333;
    font-size: 100%;
    text-decoration: none;
    font-family: inherit;
}
a::before{
  content: "　";
    position: absolute;
    font-size: 0;
}

.burgerMenu-open {
  height: 100%;
  overflow: hidden;
}



`;

export default GlobalStyle;
